import { Usuario } from "./usuario.model";

export class Contacto {
    
    _id: String;
    postulacion: string;
    usuario:Usuario;
    emailPostulante:string;
    emailEmpleador:string
    nombre:string;
    telefono:string;
    urlPdf:string
    telefonoPostulante:string
    nombrePostulante:string
    apellidoPostulante:string
    categoriaPostulante:string
    cedulaPostulante:string
    ciudadPostulante:string
    direccionPostulante:string
  
}